import * as React from "react";
import styled from "styled-components";
import { ChartLegend } from "components/common";
import useDisplayName from "ai-management/token-usage/hooks/useDisplayName";
import { toSlices } from "ai-management/token-usage/charts";
const Legend = styled.div`
  display: flex;
  justify-content: center;
  max-height: 100px;
  overflow-y: auto;
`;
const UsageLegend = ({ usage, grouping, colors }) => {
  const displayName = useDisplayName();
  const values = toSlices(usage.rows, grouping);
  if (values.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Legend, { "aria-label": "Chart legend" }, /* @__PURE__ */ React.createElement(ChartLegend, { items: values.map(({ key, group }) => ({ key, label: displayName(group), color: colors.get(key) })) }));
};
export default UsageLegend;
